/**
 * @generated SignedSource<<888ba502967936cecc13445d40e05c91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type userPermContextProviderQuery$variables = {
  atlassianAccountId: string;
  cloudID: string;
};
export type userPermContextProviderQuery$data = {
  readonly devai_rovoDevAgentsUser: {
    readonly hasProductAccess: boolean | null;
    readonly isAdmin: boolean | null;
  } | null;
};
export type userPermContextProviderQuery = {
  response: userPermContextProviderQuery$data;
  variables: userPermContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudID"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "atlassianAccountId",
        "variableName": "atlassianAccountId"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudID"
      }
    ],
    "concreteType": "DevAiUser",
    "kind": "LinkedField",
    "name": "devai_rovoDevAgentsUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasProductAccess",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAdmin",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "userPermContextProviderQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "userPermContextProviderQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0be938ea1c92244159dfe62218139544",
    "id": null,
    "metadata": {},
    "name": "userPermContextProviderQuery",
    "operationKind": "query",
    "text": "query userPermContextProviderQuery(\n  $cloudID: ID!\n  $atlassianAccountId: ID!\n) {\n  devai_rovoDevAgentsUser(cloudId: $cloudID, atlassianAccountId: $atlassianAccountId) @optIn(to: \"DevAiUsers\") {\n    hasProductAccess\n    isAdmin\n  }\n}\n"
  }
};
})();

(node as any).hash = "484f74b7aaa804926094af900b594a4e";

export default node;
